import React, { useMemo } from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import styled from 'styled-components'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import { useAppSelector, useAppDispatch } from 'redux/Hook'
import {
  clearSelectedContributions,
  selectAllContributions,
} from 'redux/slices/TextAnalysis'
import {
  calculateIsChecked,
  calculateIsIndeterminate,
  getFilteredRows,
} from '../Helpers/BulkSelectHelpers'

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem 0 1.5rem;
  .MuiFormControlLabel-label {
    display: none;
  }
  .MuiFormControlLabel-root {
    margin: 0;
  }
`

const BulkSelectCheckbox = () => {
  const dispatch = useAppDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { data: currentRows, selectedContributions: selectedRows } =
    useAppSelector((state) => state.textAnalysis)

  const { isChecked, isIndeterminate } = useMemo(
    () => ({
      isChecked: calculateIsChecked(currentRows, selectedRows),
      isIndeterminate: calculateIsIndeterminate(currentRows, selectedRows),
    }),
    [currentRows, selectedRows],
  )

  const handleChange = () => {
    if (isChecked || isIndeterminate) {
      const filteredRows = getFilteredRows(currentRows, selectedRows)
      dispatch(clearSelectedContributions(filteredRows))
    } else {
      dispatch(selectAllContributions())
    }
  }

  if (isMobile) {
    return null
  }

  return (
    <CheckboxContainer data-testid="ta-bulk-select-checkbox">
      <FormControlLabel
        disabled={!currentRows.length}
        control={
          <Checkbox
            id="select-all-checkbox"
            size="small"
            indeterminate={isIndeterminate}
            checked={isChecked}
            onChange={handleChange}
            aria-label="Select all contributions"
          />
        }
        label="Select all contributions"
      />
    </CheckboxContainer>
  )
}

export { BulkSelectCheckbox }
